export default "/fonts/vendor/mdui/dist/roboto/Roboto-Bold.woff2?3b52bc86749058f144deb815c481ca5b";